import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, forwardRef, isValidElement, useMemo, } from 'react';
import { Step } from '../Step';
import { StepConnector } from '../StepConnector';
import { isElementLike } from '../../helpers/react/isElementLike';
import { StepperContext } from './Stepper.context';
import { stepperStyles } from './Stepper.styles';
import { Base } from '../Base';
import { useStyles } from '../../hooks/useStyles';
const defaultConnector = _jsx(StepConnector, {});
export const Stepper = forwardRef(function Stepper(props, forwardedRef) {
    const { styles, sx, children, activeStep, loading, connector = defaultConnector, orientation = 'horizontal', labelPosition: labelPositionProp = 'right', completed, ...other } = props;
    const { combineStyles, globalStyles } = useStyles({
        name: 'Stepper',
        styles: [stepperStyles, styles],
    });
    const isStep = (element) => !!Step.displayName && isElementLike(element, Step.displayName);
    const validChildren = Children.toArray(children)
        .filter(isValidElement)
        .filter(isStep);
    // TODO: avoid cloneElement
    const steps = validChildren.map((child, index) => cloneElement(child, {
        index,
        last: index + 1 >= validChildren.length,
        loading: loading && activeStep === index,
        ...child.props,
    }));
    const labelPosition = orientation === 'horizontal' ? labelPositionProp : 'right';
    const contextValue = useMemo(() => ({
        activeStep: activeStep !== undefined
            ? Math.max(Math.min(activeStep, validChildren.length - 1), 0)
            : undefined,
        connector,
        orientation,
        labelPosition,
        completed,
    }), [
        activeStep,
        validChildren.length,
        connector,
        orientation,
        labelPosition,
        completed,
    ]);
    return (_jsx(StepperContext.Provider, { value: contextValue, children: _jsx(Base, { ...other, sx: [
                globalStyles,
                combineStyles('host', `host$${orientation}`, labelPosition === 'bottom' && 'host$labelBottom'),
                sx,
            ], ref: forwardedRef, children: steps }) }));
});
